import { Directive, Provider } from '@angular/core';
import { AppContextDirective } from '@modules/common/directives/app-context.directive';
import { BaseAppStateService } from '@modules/common/services/base-app-state.service';
import { TaskingAppStateService } from '../services/state.service';

@Directive({
  selector: '[appTaskingAppContext]',
  standalone: true,
})
export class TaskingAppContextDirective extends AppContextDirective {
  static readonly providers = [...BaseAppStateService.provideAs(TaskingAppStateService)];

  protected getProviders(): Provider[] {
    return TaskingAppContextDirective.providers;
  }
}
